import { CreateInvoiceGroupRequest, UpdateInvoiceGroupRequest } from '@atlassian/cssxp-types-billing';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { PaymentMethod } from '@css-xp/graphtypes';

interface PaymentMethodRequest {
  transactionAccountId: string;
  invoiceGroupId?: string;
  id: string;
  name?: string;
}
const client = createAxiosClient({ baseURL: '/api/1/invoice-group' }, ServiceProxyMap.ANS);

export const updateInvoiceGroup = async (invoiceGroupRequest: UpdateInvoiceGroupRequest): Promise<void> => {
  const result = await client.put(`/${invoiceGroupRequest.invoiceGroupId}`, {
    transactionAccountId: invoiceGroupRequest.transactionAccountId,
    ...invoiceGroupRequest.data,
  });
  return result.data;
};

export const createInvoiceGroup = async (invoiceGroupRequest: CreateInvoiceGroupRequest): Promise<any> => {
  const result = await client.post(`/create/${invoiceGroupRequest.transactionAccountId}`, invoiceGroupRequest.data);
  return result.data;
};

export const updateDefaultPaymentMethod = async (invoiceGroupRequest: PaymentMethodRequest): Promise<PaymentMethod> => {
  const result = await client.put(`/${invoiceGroupRequest.invoiceGroupId}/payment-method`, {
    defaultPaymentMethodId: invoiceGroupRequest.id,
    transactionAccountId: invoiceGroupRequest.transactionAccountId,
    name: invoiceGroupRequest.name,
  });
  return result.data;
};
